import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readAllByEmisor: (emisor, filter = null) =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!, $filter: Filter) {
            Categoria {
              readAllByEmisor(emisor: $emisor, filter: $filter) {
                _id
                nombre
                descripcion
                esPorcentual
                valor
                color
              }
            }
          }
        `,
        variables: {
          emisor,
          filter
        }
      })
      .then(result => result.data.data.Categoria.readAllByEmisor),

  readById: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Categoria {
              readById(_id: $_id) {
                _id
                nombre
                descripcion
                esPorcentual
                valor
                color
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Categoria.readById),

  create: input =>
    api
      .send({
        query: gql`
          mutation create($input: CategoriaInput!) {
            Categoria {
              create(input: $input) {
                _id
                nombre
                esPorcentual
                valor
                # color
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Categoria.create),

  delete: input =>
    api
      .send({
        query: gql`
          mutation delete($input: [ID!]!) {
            Categoria {
              delete(input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { input }
      })
      .then(result => result.data.data.Categoria.delete)
}
